$(document).ready( function(){
	BannerTextCentering();
	MicrositeTable();

	$('.MicroSitePage .menu-toggle').click( function() {
		$('.microsite_menu').slideToggle();
		$(this).toggleClass('open');
	});

	$('.MicroSiteHomePage .menu-toggle').click( function() {
		$('.microsite_menu').toggleClass('showing');
		$(this).toggleClass('open');
	});
});

$(window).resize( function() {
	BannerTextCentering();
	MicrositeTable();
});

/*
	Vertically center the banner text, change with screen resize
*/
function BannerTextCentering() {
	if( $('.MicroSiteHomePage .banner-heading').length > 0 && $(window).width() > 400 ) {
		var bannerHeight = $('.banner-wrapper').height();
		var textHeight = $('.banner-heading').height();
		var padding = (bannerHeight - textHeight) / 2;
		
		$('.banner-heading').css('paddingTop', padding + 'px');
	}
}

/*
	Resize the table to equal the inner's width, change with screen resize
*/
function MicrositeTable() {
	if ($('.MicroSitePage #main .content table').length > 0){
		var innerWidth = $('#main .main-content').innerWidth();
		$('#main .content table').width(innerWidth - 40);
	}
}